import { TimesheetTableRow } from '../TimesheetsTable.types';

export const getAllExpandableKeys = (data: TimesheetTableRow[]): string[] => {
  const keys: string[] = [];

  data.forEach((row) => {
    if ('children' in row) {
      keys.push(row.key);
      if ('accountName' in row) {
        row.children.forEach((project) => {
          if ('children' in project) {
            keys.push(project.key);
          }
        });
      }
    }
  });

  return keys;
};
